"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const Constants_1 = require("./utils/Constants");
const StatsigAsyncStorage_1 = __importDefault(require("./utils/StatsigAsyncStorage"));
const StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
class Identity {
    constructor(user, overrideStableID, reactNativeUUID) {
        var _a, _b, _c;
        this.platform = null;
        this.nativeModules = null;
        this.sdkType = 'js-client';
        this.reactNativeUUID = reactNativeUUID;
        this.user = user;
        this.sdkVersion = (_b = (_a = require('../package.json')) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : '';
        this.statsigMetadata = {
            sessionID: this.getUUID(),
            sdkType: this.sdkType,
            sdkVersion: this.sdkVersion,
        };
        let stableID = overrideStableID;
        if (!StatsigAsyncStorage_1.default.asyncStorage) {
            stableID =
                (_c = stableID !== null && stableID !== void 0 ? stableID : StatsigLocalStorage_1.default.getItem(Constants_1.STATSIG_STABLE_ID_KEY)) !== null && _c !== void 0 ? _c : this.getUUID();
            StatsigLocalStorage_1.default.setItem(Constants_1.STATSIG_STABLE_ID_KEY, stableID);
        }
        if (stableID) {
            this.statsigMetadata.stableID = stableID;
        }
    }
    async initAsync() {
        let stableID = this.statsigMetadata.stableID;
        if (!stableID) {
            stableID = await StatsigAsyncStorage_1.default.getItemAsync(Constants_1.STATSIG_STABLE_ID_KEY);
            stableID = stableID !== null && stableID !== void 0 ? stableID : this.getUUID();
        }
        StatsigAsyncStorage_1.default.setItemAsync(Constants_1.STATSIG_STABLE_ID_KEY, stableID);
        this.statsigMetadata.stableID = stableID;
        return this;
    }
    getSDKType() {
        return this.sdkType;
    }
    getSDKVersion() {
        return this.sdkVersion;
    }
    getStatsigMetadata() {
        this.statsigMetadata.sdkType = this.sdkType;
        this.statsigMetadata.sdkVersion = this.sdkVersion;
        return this.statsigMetadata;
    }
    getUser() {
        return this.user;
    }
    updateUser(user) {
        this.user = user;
        this.statsigMetadata.sessionID = this.getUUID();
    }
    setSDKPackageInfo(SDKPackageInfo) {
        this.sdkType = SDKPackageInfo.sdkType;
        this.sdkVersion = SDKPackageInfo.sdkVersion;
    }
    setPlatform(platform) {
        this.platform = platform;
        this.updateMetadataFromNativeModules();
    }
    setNativeModules(nativeModules) {
        this.nativeModules = nativeModules;
        this.updateMetadataFromNativeModules();
    }
    updateMetadataFromNativeModules() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (this.platform == null || this.nativeModules == null) {
            return;
        }
        if (((_a = this.platform.OS) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === 'android') {
            this.statsigMetadata.locale =
                (_b = this.nativeModules.I18nManager) === null || _b === void 0 ? void 0 : _b.localeIdentifier;
        }
        else if (((_c = this.platform.OS) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === 'ios') {
            this.statsigMetadata.locale =
                ((_e = (_d = this.nativeModules.SettingsManager) === null || _d === void 0 ? void 0 : _d.settings) === null || _e === void 0 ? void 0 : _e.AppleLocale) ||
                    ((_g = (_f = this.nativeModules.SettingsManager) === null || _f === void 0 ? void 0 : _f.settings) === null || _g === void 0 ? void 0 : _g.AppleLanguages[0]);
        }
    }
    getUUID() {
        var _a, _b;
        return (_b = (_a = this.reactNativeUUID) === null || _a === void 0 ? void 0 : _a.v4()) !== null && _b !== void 0 ? _b : (0, uuid_1.v4)();
    }
    setRNDeviceInfo(deviceInfo) {
        var _a, _b, _c, _d, _e;
        this.statsigMetadata.appVersion = (_a = deviceInfo.getVersion()) !== null && _a !== void 0 ? _a : ''; // e.g. 1.0.1
        this.statsigMetadata.systemVersion = (_b = deviceInfo.getSystemVersion()) !== null && _b !== void 0 ? _b : ''; // Android: "4.0.3"; iOS: "12.3.1"
        this.statsigMetadata.systemName = (_c = deviceInfo.getSystemName()) !== null && _c !== void 0 ? _c : ''; // e.g. Android, iOS, iPadOS
        this.statsigMetadata.deviceModelName = (_d = deviceInfo.getModel()) !== null && _d !== void 0 ? _d : ''; // e.g. Pixel 2, iPhone XS
        this.statsigMetadata.deviceModel = (_e = deviceInfo.getDeviceId()) !== null && _e !== void 0 ? _e : ''; // e.g. iPhone7,2
    }
    setExpoConstants(expoConstants) {
        var _a, _b;
        this.statsigMetadata.appVersion =
            (_b = (_a = expoConstants.nativeAppVersion) !== null && _a !== void 0 ? _a : expoConstants.nativeBuildVersion) !== null && _b !== void 0 ? _b : ''; // e.g. 1.0.1
    }
    setExpoDevice(expoDevice) {
        var _a, _b, _c, _d;
        this.statsigMetadata.systemVersion = (_a = expoDevice.osVersion) !== null && _a !== void 0 ? _a : ''; // Android: "4.0.3"; iOS: "12.3.1"
        this.statsigMetadata.systemName = (_b = expoDevice.osName) !== null && _b !== void 0 ? _b : ''; // e.g. Android, iOS, iPadOS
        this.statsigMetadata.deviceModelName = (_c = expoDevice.modelName) !== null && _c !== void 0 ? _c : ''; // e.g. Pixel 2, iPhone XS
        this.statsigMetadata.deviceModel = (_d = expoDevice.modelId) !== null && _d !== void 0 ? _d : ''; // e.g. iPhone7,2
    }
}
exports.default = Identity;
